import React, {useRef} from "react"
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import productPageImg from "../../../../assets/website-images/product/about-banner-img.png";
import productBannerImg from "../../../../assets/website-images/product/product-banner.jpg";
import {Col, Container, Row} from "react-bootstrap";
import {motion, useInView} from "framer-motion";
import aboutImg from "../../../../assets/website-images/product/product.png";
import cImg from "../../../../assets/website-images/product/c1.png"
import cImg2 from "../../../../assets/website-images/product/c2.png"
import secImg1 from "../../../../assets/website-images/product/sec1.png"
import secImg2 from "../../../../assets/website-images/product/sec2.png"
import secImg3 from "../../../../assets/website-images/product/sec3.png"
import secImg4 from "../../../../assets/website-images/product/sec4.png"
import secImg5 from "../../../../assets/website-images/product/sec5.png"
import "./product.scss"
import {useTranslation} from "react-i18next";

export default function Product() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };
    return(
        <div className={'product'}>
            <PageBanner img={productPageImg} heading={t('products.automated_biomatric.banner_head')} bannerImg={productBannerImg}/>
            <div className={'home-about'}>
                <Container>
                    <Row>
                        <Col md={12} lg={5} className={'d-none d-lg-block'}>
                            <img src={aboutImg} className={'img-fluid'}/>
                        </Col>
                        <Col md={12} lg={7} className={'d-flex align-items-center'}>
                            <div className={'heading-section'}  ref={ref}>
                                <motion.h4
                                    className={'subheading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('products.automated_biomatric.section_1.sub_head')}
                                </motion.h4>
                                <motion.h2
                                    className={'heading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('products.automated_biomatric.section_1.head')}
                                </motion.h2>
                                <motion.p
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                    className='para'
                                >
                                    {t('products.automated_biomatric.section_1.para_1')}
                                </motion.p>
                                <motion.p
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                    className='para'
                                >
                                    {t('products.automated_biomatric.section_1.para_2')}
                                </motion.p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'product-civil'}>
                <Container>
                    <Row>
                        <div className={'heading-section'}>
                            <h2 className={'heading'}> {t('products.automated_biomatric.section_2.head')}</h2>
                        </div>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <div className={'civil-box box-1'}>
                                <div className={'img-box'}>
                                    <img src={cImg2}/>
                                </div>
                                <h4>{t('products.automated_biomatric.section_2.box_2.head')}</h4>
                                <p>
                                    {t('products.automated_biomatric.section_2.box_2.para')}
                                </p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className={'civil-box'}>
                                <div className={'img-box'}>
                                    <img src={cImg}/>
                                </div>
                                <h4>{t('products.automated_biomatric.section_2.box_1.head')}</h4>
                                <p>
                                    {t('products.automated_biomatric.section_2.box_1.para')}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'product-section'}>
                <Container>
                    <Row>
                        <Col lg={7} className={'d-flex align-items-center'}>
                            <div>
                                <h4> {t('products.automated_biomatric.section_3.head')}</h4>
                                <p>{t('products.automated_biomatric.section_3.para')}</p>
                            </div>
                        </Col>
                        <Col lg={5} className={'text-center'}>
                            <img src={secImg1} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'product-section reverse'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={5} className={'text-center'}>
                            <img src={secImg2} className={'img-fluid'}/>
                        </Col>
                        <Col lg={7} className={'d-flex align-items-center'}>
                            <div>
                                <h4> {t('products.automated_biomatric.section_4.head')}</h4>
                                <p>{t('products.automated_biomatric.section_4.para')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'product-section'}>
                <Container>
                    <Row>
                        <Col lg={7} className={'d-flex align-items-center'}>
                            <div>
                                <h4> {t('products.automated_biomatric.section_5.head')}</h4>
                                <p>{t('products.automated_biomatric.section_5.para')}</p>
                            </div>
                        </Col>
                        <Col lg={5} className={'text-center'}>
                            <img src={secImg3} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'product-section reverse'}>
                <Container>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={5} className={'text-center'}>
                            <img src={secImg4} className={'img-fluid'}/>
                        </Col>
                        <Col lg={7} className={'d-flex align-items-center'}>
                            <div>
                                <h4> {t('products.automated_biomatric.section_6.head')}</h4>
                                <p>{t('products.automated_biomatric.section_6.para')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'product-section-2'} ref={ref3}>
                <Container>
                    <Row>
                        <Col lg={8} className={'d-flex align-items-center'}>
                            <div>
                                <h4> {t('products.automated_biomatric.section_7.head')}</h4>
                                <p>{t('products.automated_biomatric.section_7.para')}</p>
                            </div>
                        </Col>
                        <Col lg={4} className={'text-center'}>
                            <img src={secImg5} className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}